module.exports = __webpack_public_path__ + "static/media/img-phone-landing.1acf9cfc.png";